import React from 'react';
import ProgressIndicator from '../../../ProgressIndicator/ProgressIndicator';
import BusinessLicenseApplicationIndex from '../BusinessLicenseApplicationFormSections/BusinessLicenseApplicationIndex';
import GeneralInfoFormSection from '../BusinessLicenseApplicationFormSections/GeneralInfoFormSection';
import OrganizationFormSection from '../BusinessLicenseApplicationFormSections/OrganizationFormSection';
import OwnershipFormSection from '../BusinessLicenseApplicationFormSections/OwnershipFormSection';
import FeeFormSection from '../BusinessLicenseApplicationFormSections/FeeFormSection';
import BusinessLicenseApplicationSuccess from '../BusinessLicenseApplicationFormSections/BusinessLicenseApplicationSuccess';

export default class BusinessLicenseApplicationContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			//business license application form params
			name: 'State of Hawaii Basic Business Application (BB-1)',
			status: 'Info Supplied - Awaiting Internal Review',
			applicationPurpose: null,
			taxIdType: null,
			isTaxLicense: true,
			taxId: null,
			taxpayerLegalFirstName: null,
			taxpayerLegalLastName: null,
			tradeDbaName: null,
			mailingCareOf: 'Travel Tax, LLC',
			mailingAddress1: 'P.O. 123',
			mailingAddress2: null,
			mailingCity: 'Littleton',
			mailingState: 'CO',
			mailingPostalCode: '80128',
			businessPhysicalLocationAddress1: null,
			businessPhysicalLocationAddress2: null,
			businessPhysicalLocationCity: null,
			businessPhysicalLocationState: null,
			businessPhysicalLocationPostalCode: null,
			legalOrganizationType: null,
			hasDisabilityExemption: false,
			businessStartDate: null,
			organizationStartDate: null,
			organizationState: null,
			accountingPeriodType: 'Calendar Year',
			fiscalYearEndingMonth: null,
			fiscalYearEndingDay: null,
			accountingPeriodEffectiveDate: 'first day of next month',
			accountingMethod: 'Cash',
			accountingMethodEffectiveDate: 'first day of next month',
			naicsBusinessActivity: '72119 - Other Traveler Accommodation',
			businessMainPhonePumber: null,
			businessAlternatePhoneNumber: null,
			businessFaxNumber: null,
			businessEmail: null,
			businessOwner1TaxIdType: null,
			businessOwner1TaxId: null,
			businessOwner1FirstName: null,
			businessOwner1LastName: null,
			businessOwner1MiddleInitial: null,
			businessOwner1ResidentialAddress1: null,
			businessOwner1ResidentialAddress2: null,
			businessOwner1ResidentialAddressCity: null,
			businessOwner1ResidentialAddressState: null,
			businessOwner1ResidentialAddressPostalCode: null,
			businessOwner1Email: null,
			businessOwner1PhoneNumber: null,
			businessOwner2TaxType: null,
			businessOwner2TaxId: null,
			businessOwner2FirstName: null,
			businessOwner2LastName: null,
			businessOwner2MiddleInitial: null,
			businessOwner2ResidentialAddress1: null,
			businessOwner2ResidentialAddress2: null,
			businessOwner2ResidentialAddressCity: null,
			businessOwner2ResidentialAddressState: null,
			businessOwner2ResidentialAddressPostalCode: null,
			businessOwner2Email: null,
			businessOwner2PhoneNumber: null,
			isWithholding: null,
			withholdingEffictiveDate: null,
			generalExciseUseType: null,
			generalExciseUseEffectiveDate: null,
			generalExciseUseFilingFrequency: 'Monthly',
			generalExciseUseFeeAmount: 20.0,
			hasTransientAccommodations: true,
			transientAccommodationsEffectiveDate: null,
			transientAccommodationsFilingFrequency: 'Monthly',
			transientAccommodationsUnits: null,
			transientAccommodationsFeeAmount: null,

			//user's location in the workflow
			isOnBusinessLicenseApplicationIndex: true,
			isOnGeneralInfoSection: false,
			isOnOrganizationSection: false,
			isOnOwnershipSection: false,
			isOnFeeSection: false,
			isOnSuccess: false
		};

		this.goToBusinessLicenseApplicationIndex = this.goToBusinessLicenseApplicationIndex.bind(
			this
		);
		this.goToGeneralInfoSection = this.goToGeneralInfoSection.bind(this);
		this.goToOrganizationSection = this.goToOrganizationSection.bind(this);
		this.goToOwnershipSection = this.goToOwnershipSection.bind(this);
		this.goToFeeSection = this.goToFeeSection.bind(this);
		this.goToSuccess = this.goToSuccess.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		// console.log('BusinessLicenseApplicationContainer - props', this.props);
		// console.log('BusinessLicenseApplicationContainer state', this.state);
		let percentCompete;
		if (this.state.isOnGeneralInfoSection) {
			percentCompete = 20;
		} else if (this.state.isOnOrganizationSection) {
			percentCompete = 40;
		} else if (this.state.isOnOwnershipSection) {
			percentCompete = 60;
		} else if (this.state.isOnFeeSection) {
			percentCompete = 80;
		} else if (this.state.isOnSuccess) {
			percentCompete = 100;
		}

		return (
			<div className="BusinessLicenseApplicationContainer">
				<div className="mx-auto w-full">
					<div>
						{!this.state.isOnBusinessLicenseApplicationIndex ? (
							<ProgressIndicator percentComplete={percentCompete} />
						) : (
							''
						)}
					</div>
					<div>
						{this.state.isOnBusinessLicenseApplicationIndex ? (
							<BusinessLicenseApplicationIndex
								continueLocation={this.goToGeneralInfoSection}
							/>
						) : this.state.isOnGeneralInfoSection ? (
							<GeneralInfoFormSection
								continueLocation={this.goToOrganizationSection}
								backLocation={this.goToBusinessLicenseApplicationIndex}
							/>
						) : this.state.isOnOrganizationSection ? (
							<OrganizationFormSection
								continueLocation={this.goToOwnershipSection}
								backLocation={this.goToGeneralInfoSection}
							/>
						) : this.state.isOnOwnershipSection ? (
							<OwnershipFormSection
								continueLocation={this.goToFeeSection}
								backLocation={this.goToOrganizationSection}
							/>
						) : this.state.isOnFeeSection ? (
							<FeeFormSection
								continueLocation={this.goToSuccess}
								backLocation={this.goToOwnershipSection}
								onSubmit={this.onSubmit}
							/>
						) : this.state.isOnSuccess ? (
							<BusinessLicenseApplicationSuccess />
						) : (
							''
						)}
					</div>
				</div>
			</div>
		);
	}

	goToBusinessLicenseApplicationIndex() {
		this.setState({
			//location
			isOnBusinessLicenseApplicationIndex: true,
			isOnGeneralInfoSection: false,
			isOnOrganizationSection: false,
			isOnOwnershipSection: false,
			isOnFeeSection: false,
			isOnSuccess: false
		});
	}

	goToGeneralInfoSection() {
		this.setState({
			//location
			isOnBusinessLicenseApplicationIndex: false,
			isOnGeneralInfoSection: true,
			isOnOrganizationSection: false,
			isOnOwnershipSection: false,
			isOnFeeSection: false,
			isOnSuccess: false
		});
	}

	goToOrganizationSection(
		applicationPurpose,
		taxIdType,
		taxId,
		taxpayerLegalFirstName,
		taxpayerLegalLastName,
		tradeDbaName
	) {
		this.setState({
			//general info section params
			applicationPurpose: applicationPurpose,
			taxIdType: taxIdType,
			taxId: taxId,
			taxpayerLegalFirstName: taxpayerLegalFirstName,
			taxpayerLegalLastName: taxpayerLegalLastName,
			tradeDbaName: tradeDbaName,

			//location
			isOnBusinessLicenseApplicationIndex: false,
			isOnGeneralInfoSection: false,
			isOnOrganizationSection: true,
			isOnOwnershipSection: false,
			isOnFeeSection: false,
			isOnSuccess: false
		});
	}

	goToOwnershipSection(
		legalOrganizationType,
		businessStartDate,
		organizationStartDate,
		organizationState,
		accountingPeriodType,
		accountingMethod,
		naicsBusinessActivity,
		businessMainPhonePumber,
		businessAlternatePhoneNumber,
		businessEmail
	) {
		this.setState({
			//org section params
			legalOrganizationType: legalOrganizationType,
			businessStartDate: businessStartDate,
			organizationStartDate: organizationStartDate,
			organizationState: organizationState,
			accountingPeriodType: accountingPeriodType,
			accountingMethod: accountingMethod,
			naicsBusinessActivity: naicsBusinessActivity,
			businessMainPhonePumber: businessMainPhonePumber,
			businessAlternatePhoneNumber: businessAlternatePhoneNumber,
			businessEmail: businessEmail,

			//location
			isOnBusinessLicenseApplicationIndex: false,
			isOnGeneralInfoSection: false,
			isOnOrganizationSection: false,
			isOnOwnershipSection: true,
			isOnFeeSection: false,
			isOnSuccess: false
		});
	}

	goToFeeSection(
		businessOwner1TaxIdType,
		businessOwner1TaxId,
		businessOwner1FirstName,
		businessOwner1LastName,
		businessOwner1ResidentialAddress1,
		businessOwner1ResidentialAddress2,
		businessOwner1ResidentialAddressCity,
		businessOwner1ResidentialAddressState,
		businessOwner1ResidentialAddressPostalCode,
		businessOwner1Email,
		businessOwner1PhoneNumber,
		businessOwner2TaxType,
		businessOwner2TaxId,
		businessOwner2FirstName,
		businessOwner2LastName,
		businessOwner2MiddleInitial,
		businessOwner2ResidentialAddress1,
		businessOwner2ResidentialAddress2,
		businessOwner2ResidentialAddressCity,
		businessOwner2ResidentialAddressState,
		businessOwner2ResidentialAddressPostalCode,
		businessOwner2Email,
		businessOwner2PhoneNumber
	) {
		this.setState({
			//ownership section params
			businessOwner1TaxIdType: businessOwner1TaxIdType,
			businessOwner1TaxId: businessOwner1TaxId,
			businessOwner1FirstName: businessOwner1FirstName,
			businessOwner1LastName: businessOwner1LastName,
			businessOwner1ResidentialAddress1: businessOwner1ResidentialAddress1,
			businessOwner1ResidentialAddress2: businessOwner1ResidentialAddress2,
			businessOwner1ResidentialAddressCity: businessOwner1ResidentialAddressCity,
			businessOwner1ResidentialAddressState: businessOwner1ResidentialAddressState,
			businessOwner1ResidentialAddressPostalCode: businessOwner1ResidentialAddressPostalCode,
			businessOwner1Email: businessOwner1Email,
			businessOwner1PhoneNumber: businessOwner1PhoneNumber,
			businessOwner2TaxType: businessOwner2TaxType,
			businessOwner2TaxId: businessOwner2TaxId,
			businessOwner2FirstName: businessOwner2FirstName,
			businessOwner2LastName: businessOwner2LastName,
			businessOwner2MiddleInitial: businessOwner2MiddleInitial,
			businessOwner2ResidentialAddress1: businessOwner2ResidentialAddress1,
			businessOwner2ResidentialAddress2: businessOwner2ResidentialAddress2,
			businessOwner2ResidentialAddressCity: businessOwner2ResidentialAddressCity,
			businessOwner2ResidentialAddressState: businessOwner2ResidentialAddressState,
			businessOwner2ResidentialAddressPostalCode: businessOwner2ResidentialAddressPostalCode,
			businessOwner2Email: businessOwner2Email,
			businessOwner2PhoneNumber: businessOwner2PhoneNumber,

			//location
			isOnBusinessLicenseApplicationIndex: false,
			isOnGeneralInfoSection: false,
			isOnOrganizationSection: false,
			isOnOwnershipSection: false,
			isOnFeeSection: true,
			isOnSuccess: false
		});
	}
	goToSuccess(
		generalExciseUseType,
		generalExciseUseEffectiveDate,
		generalExciseUseFilingFrequency,
		generalExciseUseFeeAmount,
		transientAccommodationsEffectiveDate,
		transientAccommodationsFilingFrequency,
		transientAccommodationsUnits,
		transientAccommodationsFeeAmount
	) {
		this.setState({
			//fee section params
			generalExciseUseType: generalExciseUseType,
			generalExciseUseEffectiveDate: generalExciseUseEffectiveDate,
			generalExciseUseFilingFrequency: generalExciseUseFilingFrequency,
			generalExciseUseFeeAmount: generalExciseUseFeeAmount,
			transientAccommodationsEffectiveDate: transientAccommodationsEffectiveDate,
			transientAccommodationsFilingFrequency: transientAccommodationsFilingFrequency,
			transientAccommodationsUnits: transientAccommodationsUnits,
			transientAccommodationsFeeAmount: transientAccommodationsFeeAmount,

			//location
			isOnBusinessLicenseApplicationIndex: false,
			isOnGeneralInfoSection: false,
			isOnOrganizationSection: false,
			isOnOwnershipSection: false,
			isOnFeeSection: false,
			isOnSuccess: true
		});
	}

	onSubmit(e) {
		// console.log('Create business license application call stated...');
		// e.preventDefault();
		// e.stopPropagation();

		$.ajax({
			type: 'POST',
			url: this.props.create_business_license_application_endpoint,
			dataType: 'json',
			data: {
				business_license_application: {
					name: this.state.name,
					status: this.state.status,
					property_id: 1,
					application_purpose: this.state.applicationPurpose,
					tax_id_type: this.state.taxIdType,
					is_tax_license: this.state.isTaxLicense,
					tax_id: this.state.taxId,
					taxpayer_legal_first_name: this.state.taxpayerLegalFirstName,
					taxpayer_legal_last_name: this.state.taxpayerLegalLastName,
					trade_dba_name: this.state.tradeDbaName,
					mailing_careOf: this.state.mailingCareOf,
					mailing_address_1: this.state.mailingAddress1,
					mailing_address_2: this.state.mailingAddress2,
					mailing_city: this.state.mailingCity,
					mailing_state: this.state.mailingState,
					mailing_postal_code: this.state.mailingPostalCode,
					business_physical_location_address_1: this.state
						.businessPhysicalLocationAddress1,
					business_physical_location_address_2: this.state
						.businessPhysicalLocationAddress2,
					business_physical_location_city: this.state
						.businessPhysicalLocationCity,
					business_physical_location_state: this.state
						.businessPhysicalLocationState,
					business_physical_location_postal_code: this.state
						.businessPhysicalLocationPostalCode,
					legal_organization_type: this.state.legalOrganizationType,
					has_disability_exemption: this.state.hasDisabilityExemption,
					business_start_date: this.state.businessStartDate,
					organization_start_date: this.state.organizationStartDate,
					organization_state: this.state.organizationState,
					accounting_period_type: this.state.accountingPeriodType,
					fiscal_year_ending_month: this.state.fiscalYearEndingMonth,
					fiscal_year_ending_day: this.state.fiscalYearEndingDay,
					accounting_period_effective_date: this.state
						.accountingPeriodEffectiveDate,
					accounting_method: this.state.accountingMethod,
					accounting_method_effective_date: this.state
						.accountingMethodEffectiveDate,
					naics_business_activity: this.state.naicsBusinessActivity,
					business_main_phone_number: this.state.businessMainPhonePumber,
					business_alternate_phone_number: this.state
						.businessAlternatePhoneNumber,
					business_fax_number: this.state.businessFaxNumber,
					business_email: this.state.businessEmail,
					business_owner_1_tax_id_type: this.state.businessOwner1TaxIdType,
					business_owner_1_tax_id: this.state.businessOwner1TaxId,
					business_owner_1_first_name: this.state.businessOwner1FirstName,
					business_owner_1_last_name: this.state.businessOwner1LastName,
					business_owner_1_middle_initial: this.state
						.businessOwner1MiddleInitial,
					business_owner_1_residential_address_1: this.state
						.businessOwner1ResidentialAddress1,
					business_owner_1_residential_address_2: this.state
						.businessOwner1ResidentialAddress2,
					business_owner_1_residential_address_city: this.state
						.businessOwner1ResidentialAddressCity,
					business_owner_1_residential_address_state: this.state
						.businessOwner1ResidentialAddressState,
					business_owner_1_residential_address_postal_code: this.state
						.businessOwner1ResidentialAddressPostalCode,
					business_owner_1_email: this.state.businessOwner1Email,
					business_owner_1_phone_number: this.state.businessOwner1PhoneNumber,
					business_owner_2_tax_id_type: this.state.businessOwner1TaxIdType,
					business_owner_2_tax_id: this.state.businessOwner2TaxId,
					business_owner_2_first_name: this.state.businessOwner2FirstName,
					business_owner_2_last_name: this.state.businessOwner2LastName,
					business_owner_2_middle_initial: this.state
						.businessOwner2MiddleInitial,
					business_owner_2_residential_address_1: this.state
						.businessOwner2ResidentialAddress1,
					business_owner_2_residential_address_2: this.state
						.businessOwner2ResidentialAddress2,
					business_owner_2_residential_address_city: this.state
						.businessOwner2ResidentialAddressCity,
					business_owner_2_residential_address_state: this.state
						.businessOwner2ResidentialAddressState,
					business_owner_2_residential_address_postal_code: this.state
						.businessOwner2ResidentialAddressPostalCode,
					business_owner_2_email: this.state.businessOwner2Email,
					business_owner_2_phone_number: this.state.businessOwner2PhoneNumber,
					is_withholding: this.state.isWithholding,
					withholding_effictive_date: this.state.withholdingEffictiveDate,
					general_excise_use_type: this.state.generalExciseUseType,
					general_excise_use_effective_date: this.state
						.generalExciseUseEffectiveDate,
					general_excise_use_filing_frequency: this.state
						.generalExciseUseFilingFrequency,
					general_excise_use_fee_amount: this.state.generalExciseUseFeeAmount,
					has_transient_accommodations: this.state.hasTransientAccommodations,
					transient_accommodations_effective_date: this.state
						.transientAccommodationsEffectiveDate,
					transient_accommodations_filing_frequency: this.state
						.transientAccommodationsFilingFrequency,
					transient_accommodations_units: this.state
						.transientAccommodationsUnits,
					transient_accommodations_fee_amount: this.state
						.transientAccommodationsFeeAmount
				}
			},
			error: (response) => {
				console.log(
					'Create business license application call failed.',
					response,
					response.responseJSON.errors
				);
				this.setState({ errors: response.responseJSON.errors });
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			}
		}).done((response, status) => {
			console.log(
				'Create business license application call successful.',
				response,
				status
			);
			// this.props.continueLocation();
		});
	}
}
